
import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import FormAddproduct from '../Integration/FormAddproduct'


function DashboardAddProduto() {
  return (

      <div className='dashboard-container'>
   
      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

          <label></label>
        </div>
        <div className="downright">

        <FormAddproduct/>
        </div>
        <div className='footageright'>


        </div>

      </div>
     </div>
        
        
        </div>
   
  )
}

export default DashboardAddProduto